import { Component, OnInit, inject } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { LastExecutionHistory } from '../../models/api.model';
import { CommonModule } from '@angular/common';
import { FilterService } from '../../services/filter.service';
import { SecondsConverterPipe } from '../../pipe/seconds-converter.pipe';
import { MinutesToHoursConverterPipe } from '../../pipe/minutes-to-hours-converter.pipe';
import { MiliSecondsConverterPipe } from '../../pipe/mili-seconds-converter.pipe';
import { SubtractFiveHoursPipe } from '../../pipe/subtract-five-hours.pipe';
import { Dialog } from '@angular/cdk/dialog';
import { ExecutionHistoryModalComponent } from '../execution-history-modal/execution-history-modal.component';
import { UrlModalComponent } from '../url-modal/url-modal.component';
import { AuthService } from '../../auth/auth.service';
import { ToastService } from '../../shared/toast/toast.service';

export interface DialogData {
  id_cia: number;
  id_report: number;
}

@Component({
  selector: 'app-execution-history-table',
  standalone: true,
  imports: [CommonModule, MinutesToHoursConverterPipe, MiliSecondsConverterPipe, SubtractFiveHoursPipe ],
  templateUrl: './execution-history-table.component.html',
  styleUrls: ['./execution-history-table.component.css'],
})
export class LastExecutionHistoryTableComponent implements OnInit {
  LastExecutionHistory: LastExecutionHistory[] = [];

  private id_cia: number | null = null;

  private authService = inject(AuthService);
  private toastService = inject(ToastService);

  constructor(
    private apiService: ApiService,
    private filterService: FilterService,
    private dialog: Dialog
  ) {}

  get forceRunUsed(): boolean {
    return this.authService.isForceRunUsed();
  }

  ngOnInit(): void {
    this.filterService.selectedCompanyId$.subscribe((id_cia) => {
      this.id_cia = id_cia;
      this.apiService
        .getLastExecutionDetails(id_cia)
        .subscribe((response) => {
          this.LastExecutionHistory = response.list;
        });
    });
  }

  onRowClick(execution: LastExecutionHistory) {
    this.dialog.open<String>(ExecutionHistoryModalComponent, {
      width: '1200px',
      data: {id_cia: execution.id_cia, id_report: execution.id_report}
    })
  }

  showApiUrl(execution: LastExecutionHistory) {
    this.dialog.open(UrlModalComponent, {
      width: '1200px',
      data: { id_report: execution.id_report }
    });
  }

  forceRun(execution: LastExecutionHistory) {
    if (this.forceRunUsed) {
      this.toastService.info(
        'Refresh ya usado',
        'Solo se permite un refresh por sesión. Cierra sesión y vuelve a ingresar.'
      );
      return;
    }
    this.apiService.postForceRun(execution.id_cia, execution.id_report).subscribe({
      next: () => {
        this.authService.markForceRunUsed();
        this.toastService.success(
          'Refresh enviado',
          'El reporte se está regenerando.'
        );
      },
      error: (err) => {
        const msg =
          (err?.error && (typeof err.error === 'string' ? err.error : err.error?.message)) ||
          'No se pudo enviar el refresh.';
        this.toastService.error('Error', msg);
      }
    });
  }
}
